import { schema as schemaEfficiency } from '../Utils/Efficiency'
import { schema as schemaHeatmap } from '../ReportsAndStatistics/Energy/Heatmap/types'
import { schema as schemaHeatmapBuilding } from '../ReportsAndStatistics/Energy/HeatmapBuilding/types'
import { schema as schemaHeatPumpCOP } from '../KPIs/HeatPumpCOP/types'
import { schema as P_AirHandlingUnit } from './AirHandlingUnits/P_AirHandlingUnit/types';
import { schema as P_HeatingGenerator } from './Heatings/P_HeatingGenerator/types';
import { schema as P_HeatingOutlet } from './Heatings/P_HeatingOutlet/types';
import { schema as P_HeatingPuffer} from './Heatings/P_HeatingPuffer/types';
import { schema as P_CoolingGenerator } from './Coolings/P_CoolingGenerator/types';
import { schema as P_CoolingOutlet } from './Coolings/P_CoolingOutlet/types';
import { schema as P_HeatingCoolingOutlet } from './HeatingCoolings/P_HeatingCoolingOutlet/types';
import { TAutomationApp } from '../types';

export const PlantInsightApps = [
    //schemaEfficiency,
    //schemaHeatmap, 
    schemaHeatmapBuilding,
    schemaHeatPumpCOP
]

export const PlantSchemas = [
    P_AirHandlingUnit,
    P_HeatingGenerator,
    P_HeatingOutlet,
    P_HeatingPuffer,
    P_CoolingGenerator,
    P_CoolingOutlet,
    P_HeatingCoolingOutlet,
]

export type TPlant = {
} & TUnit

export type TUnit = {
    isOn: boolean,
    isMan: boolean,
    errSum: boolean,
} & TAutomationApp